module.exports = __webpack_public_path__ + "img/Icon_Tag_Pro.fe3b2430.svg";